








































































































import { computed, defineComponent, ref, SetupContext } from '@vue/composition-api';
import Confirmation from '@/components/utils/Confirmation.vue';
import Entity from '@/models/entities/Entity';
import { EntityType } from '@/store/entityModules/types';
import { getEntityStorePath } from '@/store/entityModules/utils';
import { getNounPluralForm } from '@/utils/formatting';

interface Props {
  item: Entity;
  title: string;
  entityType: EntityType;
  loading: boolean;
  isNew: boolean;
  isDeletable: boolean;
  deleteRules?: Array<(a: any) => string | boolean>;
  defaultPageUrl?: string;
  maxWidth?: string;
  validated?: () => boolean;
}

const Component = defineComponent({
  name: 'EntityDialog',

  props: {
    item: Object,
    title: String,
    entityType: String,
    loading: Boolean,
    isNew: Boolean,
    isDeletable: Boolean,
    deleteRules: Array,
    defaultPageUrl: String,
    maxWidth: String,
    validated: Function,
  },

  components: {
    Confirmation,
  },

  setup(props: Props, { root: { $store, $router } }: SetupContext) {
    const valid = ref(true);

    const storePath = computed(() => getEntityStorePath(props.entityType));

    function create() {
      $store.dispatch(`${storePath.value}/addItem`, props.item);
      $store.dispatch(`${storePath.value}/fetchItems`);
      close();
    }

    function save() {
      $store.dispatch(`${storePath.value}/updateItem`, props.item);
      $store.dispatch(`${storePath.value}/fetchItems`);
      close();
    }

    function deleteItem(confirmed: boolean) {
      if (!confirmed) return;

      if (props.item) {
        const id = props.item.id;
        $store.dispatch(`${storePath.value}/deleteItem`, id);
        close();
      }
    }

    function close() {
      const entityPath =
        props.defaultPageUrl === undefined
          ? getNounPluralForm(props.entityType)
          : props.defaultPageUrl;
      $router.push(`/${entityPath}`);
    }

    return {
      valid,
      deleteItem,
      close,
      save,
      create,
    };
  },
});

export default Component;
